import { useQuery, UseQueryResult } from 'react-query';
import { accountInformation as getAccountInformation } from '@creditas-lab/auth-sdk';
import { handleUnauthorizedError } from '../../services/queryClient';
import { ReactQueryKeys } from './keys';

export type Claim = {
  taken: boolean;
  status: string;
  type: string;
};

export type AccountInformation = {
  id: string;
  screenName: string;
  authenticationClaims: Claim[];
};

const useGetAccountInformation = (): UseQueryResult<AccountInformation, Error> => {
  return useQuery(
    ReactQueryKeys.GET_ACCOUNT_INFORMATION,
    () => {
      return getAccountInformation();
    },
    {
      onError: (error: Error): void => {
        handleUnauthorizedError(error);
      },
    },
  );
};

export { useGetAccountInformation };
